$('.sticky-scrollbar').each(function() {
    let $scrolled = $($(this).data('for'));
    let update = () => $(this).css('--scroll-width', `${$scrolled.prop('scrollWidth')}px`);
    update();
    let observer = new ResizeObserver(update);
    $scrolled.children().each((i, el) => observer.observe(el));
    $(this).on('scroll', () => $scrolled.scrollLeft($(this).scrollLeft()));
    $scrolled.on('scroll', () => $(this).scrollLeft($scrolled.scrollLeft()));
});